export default __webpack_public_path__ + "images/fce4ab49131c867b24ae8704865afe24-ios-share-icon.svg";